import React, { createContext, useContext, useState, useCallback } from 'react';
import { Backdrop, CircularProgress, Typography, Box } from '@mui/material';

// Создаём контекст
const GlobalLoadingContext = createContext();

// Хук для использования контекста
export const useGlobalLoading = () => {
  const context = useContext(GlobalLoadingContext);
  if (!context) {
    throw new Error('useGlobalLoading must be used within a GlobalLoadingProvider');
  }
  return context;
};

// Провайдер контекста
export const GlobalLoadingProvider = ({ children }) => {
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [activeRequests, setActiveRequests] = useState(0);

  // Увеличить счётчик запросов
  const startLoading = useCallback((msg = '') => {
    setActiveRequests(prev => {
      const newCount = prev + 1;
      if (newCount === 1) {
        setLoading(true);
        setMessage(msg);
      }
      return newCount;
    });
  }, []);

  // Уменьшить счётчик запросов
  const stopLoading = useCallback(() => {
    setActiveRequests(prev => {
      const newCount = Math.max(0, prev - 1);
      if (newCount === 0) {
        setLoading(false);
        setMessage('');
      }
      return newCount;
    });
  }, []);

  // Установить сообщение
  const setLoadingMessage = useCallback((msg) => {
    setMessage(msg);
  }, []);

  return (
    <GlobalLoadingContext.Provider value={{ loading, startLoading, stopLoading, setLoadingMessage }}>
      {children}
      <Backdrop
        sx={{
          color: '#8fa6bb',
          zIndex: (theme) => theme.zIndex.modal + 1,
          backgroundColor: 'rgba(25, 43, 62, 0.32)',
          display: 'flex',
          flexDirection: 'column',
          gap: 2,
        }}
        open={loading}
      >
        <CircularProgress color="inherit" size={36} thickness={3} aria-label={message || "Загрузка страницы"} />
        {message && (
          <Box sx={{ textAlign: 'center' }}>
            <Typography variant="body2" sx={{ color: "#c1ccd6" }}>
              {message}
            </Typography>
          </Box>
        )}
      </Backdrop>
    </GlobalLoadingContext.Provider>
  );
};

export default GlobalLoadingContext;
